import Link from 'next/link'
import { siteConfig } from '@/config/site'

// ============================================================================
// LOGO — NovaVerse brand mark (an orbiting nova star).
// ============================================================================

interface LogoProps {
  className?: string
  /** Render as a link to home (default) or plain mark. */
  asLink?: boolean
}

function Mark(): React.JSX.Element {
  return (
    <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-nova-600 to-aqua-500 shadow-lg shadow-nova-600/30">
      <svg viewBox="0 0 24 24" className="h-5 w-5 text-white" fill="none" aria-hidden="true">
        <path
          d="M12 2.5l1.9 5.3 5.6.2-4.4 3.4 1.6 5.4L12 13.9 7.3 20.2l1.6-5.4-4.4-3.4 5.6-.2L12 2.5z"
          fill="currentColor"
        />
      </svg>
    </span>
  )
}

export function Logo({ className = '', asLink = true }: LogoProps): React.JSX.Element {
  const content = (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <Mark />
      <span className="text-lg font-bold tracking-tight text-foreground">
        {siteConfig.name}
      </span>
    </span>
  )

  if (!asLink) return content

  return (
    <Link href={siteConfig.routes.home} aria-label={`${siteConfig.name} home`}>
      {content}
    </Link>
  )
}
